import * as types from "./DashboardManagerType";

const INITIAL_STATE = {
  collectionVsTarget: [],
  collectionCustomerwise: [],
  collectionAgingwiseWOTax: [],
  osod: [],
  osodCustomerwise: [],
  osodExecutivewise: [],
  onAccountExecutivewise: [],
  onAccountCustomerwise: [],
  odAgewise: [],
  odCustomerwise: [],
  salesNewProduct: [],
  salesNewProductReport: [],
  soCategorywise: [],
  soCustomerwise: [],
  soExecutivewise: [],
  salesCustomerwise: [],
  salesCategorywise: [],
  salesProductCategorywise: [],
  salesStatewise: [],
  salesCustomerCategorywise: [],
  // --- Daily Review Dashboard ---
  reviewTargetVsActualSales: [],
  reviewExecutiveOsodPercentage: [],
  reviewIncentiveTargetVsActual: [],
  reviewSalesOrderPending: [],
  reviewCategoryWiseSales: [],
  reviewCustomerWiseSalesQtyValue: [],
  reviewDistributorTargetVsActual: [],
  reviewCategoryWiseSalesValue: [],
};

const DashboardManagerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_COLLECTION_VS_TARGET:
      return { ...state, collectionVsTarget: action.payload.list };
    case types.SET_COLLECTION_CUSTOMERWISE:
      return { ...state, collectionCustomerwise: action.payload.list };
    case types.SET_COLLECTION_AGINGWISE_WOTAX:
      return { ...state, collectionAgingwiseWOTax: action.payload.list };
    case types.SET_OSOD:
      return { ...state, osod: action.payload.list };
    case types.SET_OSOD_CUSTOMERWISE:
      return { ...state, osodCustomerwise: action.payload.list };
    case types.SET_OSOD_EXECUTIVEWISE:
      return { ...state, osodExecutivewise: action.payload.list };
    case types.SET_ONACCOUNT_EXECUTIVEWISE:
      return { ...state, onAccountExecutivewise: action.payload.list };
    case types.SET_ONACCOUNT_CUSTOMERWISE:
      return { ...state, onAccountCustomerwise: action.payload.list };
    case types.SET_OD_AGEWISE:
      return { ...state, odAgewise: action.payload.list };
    case types.SET_OD_CUSTOMERWISE:
      return { ...state, odCustomerwise: action.payload.list };
    case types.SET_SALES_NEW_PRODUCT:
      return { ...state, salesNewProduct: action.payload.list };
    case types.SET_SALES_NEW_PRODUCT_REPORT:
      return { ...state, salesNewProductReport: action.payload.list };
    case types.SET_SO_CATEGORYWISE:
      return { ...state, soCategorywise: action.payload.list };
    case types.SET_SO_CUSTOMERWISE:
      return { ...state, soCustomerwise: action.payload.list };
    case types.SET_SO_EXECUTIVEWISE:
      return { ...state, soExecutivewise: action.payload.list };
    case types.SET_SALES_CUSTOMERWISE:
      return { ...state, salesCustomerwise: action.payload.list };
    case types.SET_SALES_CATEGORYWISE:
      return { ...state, salesCategorywise: action.payload.list };
    case types.SET_SALES_PRODUCT_CATEGORYWISE:
      return { ...state, salesProductCategorywise: action.payload.list };
    case types.SET_SALES_STATEWISE:
      return { ...state, salesStatewise: action.payload.list };
    case types.SET_SALES_CUSTOMER_CATEGORYWISE:
      return { ...state, salesCustomerCategorywise: action.payload.list };
    // --- Daily Review Dashboard ---
    case types.SET_REVIEW_TARGET_VS_ACTUAL_SALES:
      return { ...state, reviewTargetVsActualSales: action.payload.list };
    case types.SET_REVIEW_EXEC_OSOD_PERCENTAGE:
      return { ...state, reviewExecutiveOsodPercentage: action.payload.list };
    case types.SET_REVIEW_INCENTIVE_TARGET_VS_ACTUAL:
      return { ...state, reviewIncentiveTargetVsActual: action.payload.list };
    case types.SET_REVIEW_SALES_ORDER_PENDING:
      return { ...state, reviewSalesOrderPending: action.payload.list };
    case types.SET_REVIEW_CATEGORY_WISE_SALES:
      return { ...state, reviewCategoryWiseSales: action.payload.list };
    case types.SET_REVIEW_CUSTOMER_WISE_SALES_QTY_VALUE:
      return { ...state, reviewCustomerWiseSalesQtyValue: action.payload.list };
    case types.SET_REVIEW_DISTRIBUTOR_TARGET_VS_ACTUAL:
      return { ...state, reviewDistributorTargetVsActual: action.payload.list };
    case types.SET_REVIEW_CATEGORY_WISE_SALES_VALUE:
      return { ...state, reviewCategoryWiseSalesValue: action.payload.list };
    default:
      return state;
  }
};

export default DashboardManagerReducer;